"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapTestTypeDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const SupplierTestTypeDTO_1 = require("./SupplierTestTypeDTO");
const SimpleTestTypeDTO_1 = require("./SimpleTestTypeDTO");
const NormalTestTypeDTO_1 = require("./NormalTestTypeDTO");
class WrapTestTypeDTO {
}
exports.WrapTestTypeDTO = WrapTestTypeDTO;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => SupplierTestTypeDTO_1.SupplierTestTypeDTO, {
        discriminator: {
            property: 'testVariant',
            subTypes: [
                {
                    value: SimpleTestTypeDTO_1.SimpleTestTypeDTO,
                    name: 'simple'
                },
                {
                    value: NormalTestTypeDTO_1.NormalTestTypeDTO,
                    name: 'normal'
                }
            ]
        },
        keepDiscriminatorProperty: true
    }),
    __metadata("design:type", Object)
], WrapTestTypeDTO.prototype, "type", void 0);
